module.exports = __webpack_public_path__ + "img/dy.06fd14c8.png";